import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Profile from './views/Profile.vue'
import Trainer from './views/trainers/Trainer.vue'
import ShowTrainer from './views/trainers/ShowTrainer.vue'
import Kine from './views/kine/Kine.vue'
import ShowKine from './views/kine/ShowKine'
import Nutrition from './views/nutrition/Nutrition.vue'
import ShowNutrition from './views/nutrition/ShowNutrition'
import AppHeader from './components/shared/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import BusinessSelectPack from './views/business/BusinessSelectPack.vue'
import ErrorPage from './views/ErrorPage.vue';

import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '*',
    //   name: 'ErrorPage',
    //   component: ErrorPage
    // },
    {
      path: '/',
      name: 'landing',
      component: require("@/views/Home").default
    },
    // {
    //   meta: { layout: "custom" },
    //   path: '/login',
    //   component: Login
    // },
    // {
    //   meta: { layout: "custom" },
    //   path: '/register',
    //   name: 'ChooseType',
    //   components: require("@/views/signup/ChooseType")
    // },
    /**
     * Route for signup
     */
    // {
    //   meta: { layout: "custom" },
    //   path: '/signup/user',
    //   name: 'UserSignup',
    //   components: require("@/views/signup/UserSignup")
    // },
    // {
    //   meta: { layout: "custom" },
    //   path: '/signup/coach',
    //   name: 'CoachSignup',
    //   components: require("@/views/signup/CoachSignup")
    // },
    // {
    //   path: '/trainer',
    //   name: 'trainer',
    //   components: {
    //     header: AppHeader,
    //     default: Trainer,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/trainer/:id',
    //   name: 'ShowTrainer',
    //   props: true,
    //   components: {
    //     header: AppHeader,
    //     default: ShowTrainer,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/kine',
    //   name: 'kine',
    //   components: {
    //     header: AppHeader,
    //     default: Kine,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/kine/:id',
    //   name: 'ShowKine',
    //   props: true,
    //   components: {
    //     header: AppHeader,
    //     default: ShowKine,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/nutrition',
    //   name: 'nutrition',
    //   components: {
    //     header: AppHeader,
    //     default: Nutrition,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/nutrition/:id',
    //   name: 'ShowNutrition',
    //   props: true,
    //   components: {
    //     header: AppHeader,
    //     default: ShowNutrition,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/profile',
    //   name: 'profile',
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   },
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard
    // },
    // {
    //   path: '/profile/packs', component: () => import('./components/business/UpdatePacks.vue'),
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard
    // },
    // {
    //   path: '/business',
    //   name: 'business',
    //   component: BusinessSelectPack
    // },
    // {
    //   path: '/verify',
    //   name: 'verify email',
    //   component: () => import('./components/authentication/VerifyEmail.vue')
    // },
    // {
    //   path: '/logging',
    //   name: 'Social Login',
    //   component: () => import('./components/authentication/Logging.vue')
    // },
    // {
    //   path: '/dashboard',
    //   name: 'Dashboard',
    //   meta: { layout: "dashboard" },
    //   component: () => import('./views/dashboard/Dashboard')
    // },
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   name: "Dashboard Index",
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/index', component: () => import('./views/dashboard/IndexDashboard')
    // },
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/calendar', component: () => import('./views/dashboard/CalendarDashboard')
    // },
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/live', component: () => import('./views/dashboard/LiveTraining')
    // },
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/notifications', component: () => import('./views/dashboard/Notifications')
    // }, 
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/billing', component: () => import('./views/dashboard/Billing')
    // }, 
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/requests', component: () => import('./views/dashboard/CoachingRequests')
    // },
    // {
    //   meta: { layout: "dashboard", requiresAuth: true },
    //   beforeEnter: AuthGuard,
    //   path: '/dashboard/insights', component: () => import('./views/dashboard/Insights')
    // },
    // {
    //   path: '/reset',
    //   name: 'Reset Password',
    //   component: () => import('./components/authentication/ResetPassword.vue')
    // },
    // {
    //   path: '/resetReq',
    //   name: 'Request Reset Password',
    //   component: () => import('./components/authentication/RequestResetPassword.vue')
    // },
    // {
    //   path: '/checkEmail',
    //   name: 'check verification email',
    //   component: () => import('./components/CheckVerification.vue')
    // },
    // {
    //   path: '/checkout',
    //   name: 'Checkout',
    //   component: () => import('./views/Checkout.vue')
    // },
    // {
    //   path: '/order',
    //   name: 'Order',
    //   component: () => import('./views/Order.vue')
    // },
    // {
    //   path: '/payment',
    //   name: 'Payment',
    //   component: () => import('./views/Payment.vue')
    // },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/cgu',
      name: 'cgu',
      component: () => import('./views/cgu.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/Services.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    }
  ]
})
